import React from 'react';
import { connect } from 'react-redux';

const Advertisement = props => {
  return (
    <div style={{padding: '12px'}}>
      <a
        href='http://www.maschio.com/assets/Uploads/W19580088RDepliantSPit-en-frlow5.pdf'
        target='_blank'
        style={{color: '#f44336'}}
      >Брошюра сеялка SP</a>
    </div>
  );
}

export default connect()(Advertisement);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/category/category-info/advertisement.js